import Image from "next/image";

/**
 * Sello oficial del programa INCIBE Emprende Ventures.
 *
 * El archivo lleva embebidas las marcas de financiación de la Unión Europea
 * (NextGenerationEU) y del Plan de Recuperación, Transformación y Resiliencia:
 * no debe recortarse, recolorearse ni separarse de esas marcas.
 */
const TEXTO_ALTERNATIVO =
    "Sello del programa INCIBE Emprende Ventures, financiado por la Unión Europea (NextGenerationEU) dentro del Plan de Recuperación, Transformación y Resiliencia";

interface PropiedadesSelloIncibe {
    /** Lado del sello en píxeles CSS. */
    lado: number;
    /** Carga prioritaria: activar solo cuando el sello es visible sin scroll. */
    prioritario?: boolean;
    className?: string;
}

export default function SelloIncibe({ lado, prioritario = false, className = "" }: PropiedadesSelloIncibe) {
    return (
        <Image
            src="/images/sellos/incibe-emprende-ventures.png"
            alt={TEXTO_ALTERNATIVO}
            width={lado}
            height={lado}
            sizes={`${lado}px`}
            priority={prioritario}
            className={className}
            style={{ width: lado, height: "auto" }}
        />
    );
}
